export function containSameElements(
  lhs: Array<string | number>,
  rhs: Array<string | number>
): boolean {
  lhs = lhs || [];
  rhs = rhs || [];
  const intersection = [...new Set(lhs.concat(rhs))];
  return intersection.length == lhs.length && intersection.length == rhs.length;
}
